import { Injectable, OnDestroy } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { filter, Subscription } from "rxjs";

const LANG_FR = "fr";

@Injectable({ providedIn: "root" })
export class LanguageService implements OnDestroy {
    private sub?: Subscription;

    constructor(
        private readonly router: Router,
        private readonly translate: TranslateService,
    ) {
        this.translate.addLangs([LANG_FR]);
        this.translate.setFallbackLang(LANG_FR);

        this.sub = this.router.events
            .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
            .subscribe(() => this.applyFrenchLang());

        this.applyFrenchLang();
    }

    ngOnDestroy(): void {
        this.sub?.unsubscribe();
    }

    setLang(_lang: typeof LANG_FR): void {
        this.applyFrenchLang();
    }

    private applyFrenchLang(): void {
        this.translate.use(LANG_FR);
        if (typeof document !== "undefined") {
            document.documentElement.lang = LANG_FR;
        }
    }
}
